import page from './page'
import NeverKnowinglyUndersoldClaimForm from '../components/never-knowingly-undersold-claim/never-knowingly-undersold-claim-form'
import { ReactAccordion } from '../components/accordion'
import { DatePickerInput } from '../components/inputs/date-picker'

page('.never-knowingly-undersold-claim-main', () => {
  let accordions = document.querySelectorAll('[data-accordion]');
  if (accordions) {
    for (let i = 0; i < accordions.length; i++) {
      ReactAccordion.init(accordions[i], i);
    }
  }

  let datePickerContainer = document.querySelector('.date-picker--container');
  let datePickerInput = document.getElementById('product-details--purchase-date');
  if (datePickerContainer && datePickerInput) {
    DatePickerInput.addChangeListenerToInputs(datePickerContainer, createChangeListener(datePickerInput));
  }

  function createChangeListener(elem) {
    return () => {
      const day = document.getElementById(elem.id + '--day');
      const month = document.getElementById(elem.id + '--month');
      const year = document.getElementById(elem.id + '--year');

      const dayValue = parseInt(day.value);
      const monthValue = parseInt(month.value);
      const yearValue = parseInt(year.value);

      if (DatePickerInput.isValidDate(yearValue, monthValue, dayValue)) {
        elem.value = DatePickerInput.padTo2Digits(dayValue) + '/'
          + DatePickerInput.padTo2Digits(monthValue)
          + '/' + DatePickerInput.padTo2Digits(yearValue);
        elem.classList.remove('invalid');
      } else {
        elem.classList.add('invalid');
      }
    }
  }

  const formElem = document.querySelector('.never-knowingly-undersold-claim-form');
  new NeverKnowinglyUndersoldClaimForm(formElem).init();
});
